import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { BarChartOutlined, QrcodeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import theme from "../config/theme";

const { Title, Text } = Typography;

const ManagerDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const quickActions = [
    {
      title: t("statistics"),
      description: t("statistics_description"),
      icon: <BarChartOutlined style={{ fontSize: theme.iconSizes.xl, color: theme.colors.info }} />,
      path: "/manager/stats",
      color: theme.colors.info,
    },
    {
      title: t("in_store_qr_code"),
      description: t("in_store_qr_code_description"),
      icon: (
        <QrcodeOutlined
          style={{ fontSize: theme.iconSizes.xl, color: theme.colors.primary.main }}
        />
      ),
      path: "/manager/qr-code",
      color: theme.colors.primary.main,
    },
  ];

  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom: theme.spacing.xxl }}>
        <Title level={2} style={{ margin: 0, color: theme.colors.text.primary }}>
          {t("welcome_manager_dashboard")}
        </Title>
        <Text
          style={{ fontSize: theme.typography.fontSize.lg, color: theme.colors.text.secondary }}
        >
          {t("manager_dashboard_welcome_description")}
        </Text>
      </div>

      {/* Quick Actions */}
      <div style={{ marginBottom: theme.spacing.xxl }}>
        <Title level={3} style={{ marginBottom: theme.spacing.lg }}>
          {t("quick_actions")}
        </Title>
        <Row gutter={[24, 24]}>
          {quickActions.map((action) => (
            <Col xs={24} sm={12} lg={8} key={action.path}>
              <Card
                hoverable
                onClick={() => navigate(action.path)}
                style={{
                  borderRadius: theme.borderRadius.xl,
                  boxShadow: theme.shadows.base,
                  border: `2px solid ${theme.colors.neutral.gray200}`,
                  cursor: "pointer",
                  height: "100%",
                }}
                styles={{
                  body: {
                    padding: theme.spacing.xl,
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: theme.layout.card.minHeight,
                  },
                }}
              >
                <div style={{ marginBottom: theme.spacing.md }}>{action.icon}</div>
                <Title level={5} style={{ margin: 0, marginBottom: theme.spacing.xs }}>
                  {action.title}
                </Title>
                <Text type="secondary" style={{ fontSize: theme.typography.fontSize.sm }}>
                  {action.description}
                </Text>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default ManagerDashboard;
